import HeypsterFetch from "./HeypsterFetch.js";
import HeypsterGif from "./HeypsterGif.js";
import HeypsterTag from "./HeypsterTag.js";

export default class HeypsterPopup {

    constructor(apiKey, language = 'fr', position, appearance = 'v1') {
        this.popupElement = null;
        this.popupContainer = null;
        this.currentDisplay = appearance === 'v1' ? 'categories' : 'trending';
        this.currentCategory = null;
        this.language = language;
        this.positionLogo = position;
        this.translations = null;
        this.appearance = appearance; 
        this.displayBackButton = false;

        this.tab = null;

        this.gifHandler = new HeypsterFetch(apiKey, language);
        this.gifsObject = null;
        this.initialize();

        if(appearance === 'v1'){
            this.currentDisplay = 'categories';
        }else{
            this.currentDisplay = 'trending';
        }
        
    }

    async initialize(){
        this.loadStyles();
        await this.loadTranslations();
        return this.createPopup();
    }

    async loadTranslations() {
        try {
            const url = "https://heypster-gif.com/sdk/V2/assets/lang/categories.json";
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Failed to fetch translations: ${response.status}`);
            }
            this.translations = await response.json();
        } catch (error) {
            console.error('Error fetching translations:', error);
        }
    }

    // Fonction pour charger le CSS
    loadStyles() {
        const styleLink = document.createElement('link');
        styleLink.rel = 'stylesheet';
        styleLink.type = 'text/css';
        styleLink.href = "https://heypster-gif.com/sdk/V2/assets/css/style.css";
        document.head.appendChild(styleLink);
    }

    // Construct categories images via data-tag
    loadCategories(){
        const categoriesList = [
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/applaud.jpg",
                imageTag: 'applaud',
                imageTagId: 4444
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/angry.jpg",
                imageTag: 'angry',
                imageTagId: 487
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/coffee.jpg",
                imageTag: 'coffee',
                imageTagId: 442
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/cafeteria.jpg",
                imageTag: 'cafeteria',
                imageTagId: 953
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/hey.jpg",
                imageTag: 'hello',
                imageTagId: 467
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/impressed.jpg",
                imageTag: 'impressed',
                imageTagId: 815
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/wink.jpg",
                imageTag: "wink",
                imageTagId: 390
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/laugh.jpg",
                imageTag: 'laugh',
                imageTagId: 501
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/computer.jpg",
                imageTag: 'computer',
                imageTagId: 305
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/dance.jpg",
                imageTag: 'dance',
                imageTagId: 60
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/desperate.jpg",
                imageTag: 'desperate',
                imageTagId: 1264
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/glass.jpg",
                imageTag: 'glass',
                imageTagId: 6804
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/happy.jpg",
                imageTag: 'happy',
                imageTagId: 478
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/hesitation.jpg",
                imageTag: 'hesitation',
                imageTagId: 576
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/like.jpg",
                imageTag: 'like',
                imageTagId: 1320
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/mixed.jpg",
                imageTag: 'mixed',
                imageTagId: 1241
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/panic.jpg",
                imageTag: 'panic',
                imageTagId: 955
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/phone.jpg",
                imageTag: 'phone',
                imageTagId: 366
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/reflect.jpg",
                imageTag: 'reflect',
                imageTagId: 484
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/sad.jpg",
                imageTag: 'sad',
                imageTagId: 533
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/scared.jpg",
                imageTag: 'scared',
                imageTagId: 902
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/shocked.jpg",
                imageTag: 'shocked',
                imageTagId: 431
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/shrug.jpg",
                imageTag: "shrug",
                imageTagId: 995
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/smile.jpg",
                imageTag: 'smile',
                imageTagId: 398
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/thank-you.jpg",
                imageTag: 'thank-you',
                imageTagId: 400
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/tired.jpg",
                imageTag: 'tired',
                imageTagId: 709
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/wake-up.jpg",
                imageTag: 'wake-up',
                imageTagId: 473
            },
            {
                imageLink: "https://heypster-gif.com/sdk/V2/assets/img/categories/work.jpg",
                imageTag: 'work',
                imageTagId: 236
            }
        ];

        const categoriesContainer = document.createElement('div');
        categoriesContainer.classList.add('heypster-categories');

        categoriesList.forEach(categoryObject => {

            const imgElement = document.createElement('img');
            imgElement.src = categoryObject.imageLink;
            imgElement.setAttribute('data-tag', categoryObject.imageTag);

            const translatedTitle = this.translations?.[this.language]?.[categoryObject.imageTag] || categoryObject.imageTag;
            const titleElement = document.createElement('div');
            titleElement.classList.add('popup-category-title');
            titleElement.textContent = translatedTitle;

            const categoryWrapper = document.createElement('div');
            categoryWrapper.classList.add('popup-category-wrapper');
            categoryWrapper.appendChild(imgElement);
            categoryWrapper.appendChild(titleElement);

            categoryWrapper.addEventListener('click', () => {
                this.gifHandler.setCurrentPage(1);
                this.currentCategory = categoryObject.imageTagId;
                this.currentDisplay = 'gifs'; // Changer l'affichage au clic
                this.displayBackButton = true;
                this.switchDisplay();
            });

            
            categoriesContainer.appendChild(categoryWrapper);
        });

        return categoriesContainer;
    }

    async loadGifs(gifAlreadyLoad) {

        const gifsContainer = document.createElement('div');
        gifsContainer.classList.add('heypster-content');

        if(this.displayBackButton || this.appearance === "v1"){
            // Ajout d'un bouton pour revenir aux catégories
            const backButton = document.createElement('button');
            backButton.classList.add('heypster-back-button');

            let back_tab;
            if(this.appearance === 'v1'){
                back_tab = 'categories';
            }else{
                back_tab = this.tab === 'tags' ? 'tags' : 'emojis';
            }

            backButton.textContent = back_tab === "categories" ? this.translations?.[this.language]?.["back_to_categories"] :(back_tab === "tags" ? this.translations?.[this.language]?.["back_to_tags"] : this.translations?.[this.language]?.["back_to_emojis"]);
            backButton.addEventListener('click', () => {
                document.querySelector('.heypster-search-input').value="";
                this.currentDisplay = back_tab; // Changer l'affichage au clic
                this.switchDisplay();
            });
            gifsContainer.appendChild(backButton);
            this.displayBackButton = false;
        }

        // Création de l'affichage des gifs
        const gifsGrid = document.createElement('div');
        gifsGrid.classList.add('heypster-gifs-list');
        gifsContainer.appendChild(gifsGrid);

        if(!gifAlreadyLoad){
            if(( (this.appearance === 'v2' && !this.tab)|| this.tab === 'trending') && this.tab != 'tags' && this.tab != 'emojis'){
                this.gifsObject = await this.gifHandler.getTrendingGifs();
            }else if(this.appearance === 'v1' || this.tab == 'tags'){
                this.gifsObject = await this.gifHandler.getGifsForTag(this.currentCategory);
            }else if(this.tab == 'emojis'){
                this.gifsObject = await this.gifHandler.getGifsForEmoji(this.currentCategory);
            }
        }

        // Création du message de retour
        if(this.gifsObject.message && this.gifsObject.message.length > 0){
            const responseMessager = document.createElement('p');
            responseMessager.style = "text-align:center;"
            responseMessager.innerText = this.gifsObject.message;
            gifsContainer.appendChild(responseMessager);
        }

        this.gifsObject.data.forEach(gif => {
            gifsGrid.appendChild(new HeypsterGif(gif));
        });
        

        if(this.gifsObject.links.next){
            // Bouton suivant
            const divNextButton = document.createElement('div');
            divNextButton.classList.add('heypster-div-next-button');

            const nextButton = document.createElement('button');
            nextButton.classList.add('heypster-next-button');
            nextButton.textContent = 'Plus de résultats';

            nextButton.addEventListener('click', async e => {
                try {
                    let nextPageData; 
                    this.gifsObject = await this.gifHandler.loadNextPageGifs(this.gifsObject.links.next);
                    if (this.gifsObject.next_page_url === null || this.gifsObject.links.next === null) {
                        divNextButton.style.display = 'none';
                    }
                    this.gifsObject.data.forEach(gif => {
                        gifsGrid.appendChild(new HeypsterGif(gif));
                    });
                } catch (error) {
                    //console.error('Error fetching next page GIFs:', error);
                }
            });

            divNextButton.appendChild(nextButton);
            gifsContainer.appendChild(divNextButton);
        }
        

        return gifsContainer;
    }

    loadSuggestedTags(tags){
        // Récupération de l'emplacement pour afficher les tags
        let tagContainer = document.querySelector('.heypster-tag-suggestions');
        if(!tagContainer){
            tagContainer = document.createElement('div');
            tagContainer.classList.add('heypster-tag-suggestions');
        }

        tagContainer.innerHTML = '';

        tags.forEach(tag => {
            const tagElement = new HeypsterTag(tag);
            tagElement.addEventListener('click', () => {
                this.currentCategory = tag.id;
                this.currentDisplay = 'gifs';
                this.tab = 'tags';
                
                this.switchDisplay();
                tagContainer.innerHTML = '';
                document.querySelector('.heypster-search-input').value=tag.tag;
            });
            tagContainer.appendChild(tagElement);
        });

        // Ajout des tags sous la barre de recherche
        document.querySelector('.heypster-search_bar').appendChild(tagContainer);
    }

    // Création de la popup
    createPopup() {

        this.popupElement = document.createElement('div');
        this.popupElement.id = 'heypster-popup-overlay';
        this.popupElement.style.display = 'none';
        this.popupElement.classList.add('heypster-d-none');

        this.popupContainer = document.createElement('div');
        this.popupContainer.id = 'heypster-popup';

        if(this.appearance === 'v2'){
            this.popupContainer.classList.add('heypster-sdk-v2');
        }

        // Close button
        const closeButton = document.createElement('img');
        closeButton.className = 'heypster-close-button';
        closeButton.src = "https://heypster-gif.com/sdk/V2/assets/img/croix.png";
        closeButton.addEventListener('click', () => {
            this.currentDisplay = 'categories';
            this.switchDisplay();
            this.togglePopup();
        });

        /* ******************** */
        /* Gestion HEADER POPUP */
        /* ******************** */

        // Popup content
        const header = document.createElement('div');
        header.className = 'heypster-popup-header';

        // /////////////
        /* SEARCH BAR */

        const searchBar = document.createElement('div');
        searchBar.className = 'heypster-search_bar';

        // Search input
        const searchInput = document.createElement('input');
        searchInput.type = 'text';
        searchInput.placeholder = this.translations?.[this.language]?.["search_keyword"] ||
        "Rechercher un GIF avec un mot clé.";
        searchInput.classList.add('heypster-search-input');  // Ajoutez une classe pour le style

        searchInput.addEventListener('input', async (event) => {
            const word = event.target.value.trim();
            if (word.length >= 3) {
                try {
                    this.gifHandler.currentPage = 1;
                    const tags = await this.gifHandler.getTagsFromString(word);
                    this.loadSuggestedTags(tags);
                } catch (error) {
                    //console.error('Error fetching tags:', error);
                }
            }
        });

        searchInput.addEventListener('keydown', async (event) => {
            // Vérifie si la touche pressée est "Enter"
            if (event.key === 'Enter' || event.keyCode === 13) {
                document.querySelector('.heypster-tag-suggestions').innerHTML = '';
                const searchTerm = event.target.value.trim();
                if (searchTerm.length >= 3) {
                    try {
                        // Appel à la méthode de recherche des GIFs
                        const gifsData = await this.gifHandler.searchGifsByString(searchTerm, this.language);
                        // Met à jour l'affichage des GIFs
                        this.currentCategory = null;
                        this.gifsObject = gifsData;
                        this.currentDisplay = 'gifs';
                        this.tab = 'tags';
                        this.switchDisplay(true);
                    } catch (error) {
                        //console.error('Erreur lors de la recherche des GIFs :', error);
                    }
                }
            }
        });

        document.addEventListener('click', (event) => {
            const clickedElement = event.target;
            const tagSuggestions = document.querySelector('.heypster-tag-suggestions');
            
            if (tagSuggestions && !tagSuggestions.contains(clickedElement) && clickedElement !== searchInput) {
                tagSuggestions.innerHTML = '';
            }
        });

        /////////////

        // Loupe icon
        const searchIcon = document.createElement('img');
        searchIcon.src = "https://heypster-gif.com/sdk/V2/assets/img/loupe.png";
        searchIcon.className = 'heypster-search-icon';
        searchInput.insertAdjacentElement('beforebegin', searchIcon);

        searchBar.appendChild(searchInput);
        searchBar.appendChild(searchIcon);

        // Append elements
        if(this.positionLogo === "top"){
            const logoImage = new Image();
            logoImage.className = 'heypster-logo';
            logoImage.src =  "https://heypster-gif.com/sdk/V2/assets/img/logoSDK.svg";
            header.appendChild(logoImage);
        }
        
        header.appendChild(searchBar);


        if (this.appearance === 'v2') {
            const buttonsContainer = document.createElement('div');
            buttonsContainer.classList.add('heypster-buttons-container');

            // Bouton Flamme
            const flameButton = document.createElement('img');
            flameButton.classList.add('heypster-button');
            flameButton.src = "https://heypster-gif.com/sdk/V2/assets/img/icons/flamme-active.png";
            flameButton.alt = 'Trending';
            flameButton.dataset.name = 'flamme';
            flameButton.addEventListener('click', () => {
                document.querySelector('.heypster-search-input').value="";
                this.updateActiveButton(flameButton);
                this.currentDisplay = 'trending';
                this.tab = 'trending';
                this.switchDisplay();
            });
            buttonsContainer.appendChild(flameButton);

            // Bouton Tête
            const headButton = document.createElement('img');
            headButton.classList.add('heypster-button');
            headButton.src = "https://heypster-gif.com/sdk/V2/assets/img/icons/emoji.png";
            headButton.alt = 'Emojis';
            headButton.dataset.name = 'emoji';
            headButton.addEventListener('click', () => {
                document.querySelector('.heypster-search-input').value="";
                this.updateActiveButton(headButton);
                this.currentDisplay = 'emojis';
                this.tab = 'emojis';
                this.switchDisplay();
            });
            buttonsContainer.appendChild(headButton);

            // Bouton #
            const tagButton = document.createElement('img');
            tagButton.classList.add('heypster-button');
            tagButton.src = "https://heypster-gif.com/sdk/V2/assets/img/icons/hashtag.png";
            tagButton.alt = 'Tags';
            tagButton.dataset.name = 'hashtag';
            tagButton.addEventListener('click', () => {
                document.querySelector('.heypster-search-input').value="";
                this.updateActiveButton(tagButton);
                this.currentDisplay = 'tags';
                this.tab = 'tags';
                this.switchDisplay();
            });
            buttonsContainer.appendChild(tagButton);


            header.appendChild(buttonsContainer);
        }


        /* ******************** */
        /* Intégration popupContainer */
        /* ******************** */

        header.appendChild(closeButton);
        this.popupContainer.appendChild(header);
        this.popupElement.appendChild(this.popupContainer);

        // Gestion du contenu de la popup
        this.switchDisplay();

        document.body.appendChild(this.popupElement);
    }

    // Fermer la popup
    togglePopup() {
        const popup = document.querySelector('#heypster-popup-overlay');
        popup.style.display= 'flex';
        if (popup) {
            popup.classList.toggle('heypster-d-none');
        }
    }

    // Switch between categories and gifs
    async switchDisplay(gifAlreadyLoad) {

        // Clean HTML
        let popupContent = document.querySelector('.heypster-popup-content');
        if (popupContent) popupContent.remove();

        popupContent = document.createElement('div');
        popupContent.className = 'heypster-popup-content';

        if (this.currentDisplay === 'categories') {
            popupContent.appendChild(this.loadCategories());
        } else if (this.currentDisplay === 'gifs') {
            let gifContainer = await this.loadGifs(gifAlreadyLoad);
            popupContent.appendChild(gifContainer);
        } else if (this.currentDisplay === 'trending') {
            popupContent.appendChild(await this.loadGifs());
        } else if (this.currentDisplay === 'emojis') {
            popupContent.appendChild(this.loadEmojis());
        } else if (this.currentDisplay === 'tags') {
            popupContent.appendChild(this.loadStaticTags());
        }

        if(this.positionLogo === "bottom"){

            const divLogoImage =  document.createElement('div');
            divLogoImage.className = 'heypster-div-logo-bottom';

            const logoImage = new Image();

            logoImage.className = 'heypster-logo';
            logoImage.src = "https://heypster-gif.com/sdk/V2/assets/img/powered-by-heypster.png";
            logoImage.classList.add('heypster-logo-bottom');
            divLogoImage.appendChild(logoImage);
            popupContent.appendChild(divLogoImage);
        }

        this.popupContainer.appendChild(popupContent);

    }

    // Méthode pour charger les emojis statiques
    loadEmojis() {

        const emojisContainer = document.createElement('div');
        emojisContainer.classList.add('heypster-emojis-container');

        const staticEmojis = [
            { id: 1, lib: 'angry-mad', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_angry_mad_furious_256.png" },
            { id: 2, lib: 'cry-happy', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_cry_happy_joy_laugh-256.png" },
            { id: 3, lib: 'happy-smile', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_happy_smile_joy_laugh-256.png" },
            { id: 4, lib: 'love-heart', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_love_heart_affection_happy_smile-256.png" },
            { id: 5, lib: 'money-dollar', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_money_dollar_cash_greedy-256.png" },
            { id: 6, lib: 'sad-cry', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_sad_cry_upset_unhappy-256.png" },
            { id: 7, lib: 'sad-unhappy', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_sad_unhappy-256.png" },
            { id: 8, lib: 'shocked-surprised', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_shocked_surprised-256.png" },
            { id: 9, lib: 'smile-happy', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_smile_happy_joy_sunny-256.png" },
            { id: 10, lib: 'snore-sleeping', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_snore_sleeping_sleepy_bored-256.png" },
            { id: 11, lib: 'wink-playfull', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_wink_playfull_smile_happy-256.png" },
            { id: 12, lib: 'wonder-think', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_wonder_think_thinking-256.png" },
            { id: 13, lib: 'scared', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_scared_terrified_oh_no_surprised-256.png" },
            { id: 14, lib: 'desperate', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_desperate-256.png" },
            { id: 15, lib: 'glass', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_glass-256.png" },
            { id: 16, lib: 'blowing', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/blowing_256.png" },
            { id: 17, lib: 'chut', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/chut-256.png" },
            { id: 18, lib: 'clapping', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/clapping-256.png" },
            { id: 19, lib: 'coucou', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/coucou-256.png" },
            { id: 20, lib: 'dislike', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/dislike-256.png" },
            { id: 21, lib: 'emoji_party', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/emoji_party-256.png" },
            { id: 22, lib: 'finger-crossed', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/finger-crossed-256.png" },
            { id: 23, lib: 'incomprehension_emoji', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/incomprehension_emoji.png" },
            { id: 25, lib: 'like', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/like-256.png" },
            { id: 26, lib: 'mixed', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/mixed-256.png" },
            { id: 27, lib: 'please', image: "https://heypster-gif.com/sdk/V2/assets/img/emojis/please-256.png" },
        ];

        staticEmojis.forEach(emoji => {
            const emojiElement = document.createElement('img');
            emojiElement.src = emoji.image;
            emojiElement.alt = emoji.lib;
            emojiElement.title = emoji.lib;
            emojiElement.dataset.id = emoji.id;
            emojiElement.classList.add('heypster-emoji');
            emojiElement.addEventListener('click', async () => {
                this.gifHandler.setCurrentPage(1);
                this.currentCategory = emoji.id;
                this.currentDisplay = 'gifs';
                this.displayBackButton = true;
                this.switchDisplay();
            });

            emojisContainer.appendChild(emojiElement);
        });

        return emojisContainer;
    }

    // Méthode pour charger les tags statiques
    loadStaticTags() {
        const tagsContainer = document.createElement('div');
        tagsContainer.classList.add('heypster-tags-container');

        const staticTags = [
            {
                tag: 'yes',
                tag_id: 748
            },
            {
                tag: 'no',
                tag_id: 643
            },
            {
                tag: 'maybe',
                tag_id: 587
            },
            {
                tag: 'thank you',
                tag_id: 400
            },
            {
                tag: 'really',
                tag_id: 1149
            },
            {
                tag: 'exactly',
                tag_id: 1594
            },
            {
                tag: 'relax',
                tag_id: 1492
            },
            {
                tag: 'hey',
                tag_id: 467
            },
            {
                tag: 'why',
                tag_id: 651
            },
            {
                tag: 'like',
                tag_id: 584
            },
            {
                tag: 'what',
                tag_id: 675
            },
            {
                tag: 'sorry',
                tag_id: 655
            },
            {
                tag: 'good luck',
                tag_id: 1490
            },
            {
                tag: 'okay',
                tag_id: 885
            },
            {
                tag: 'why not',
                tag_id: 671
            },
            {
                tag: 'right',
                tag_id: 1245
            },
        ];

        staticTags.forEach(tag => {
            const tagElement = document.createElement('a');
            tagElement.textContent = `#${tag.tag}`;
            tagElement.dataset.id = tag.tag_id;
            tagElement.classList.add('heypster-tag-static');
            tagElement.addEventListener('click', async () => {
                this.gifHandler.setCurrentPage(1);
                this.currentCategory = tag.tag_id;
                this.currentDisplay = 'gifs';
                this.displayBackButton = true;
                this.switchDisplay();
            });
                        
            tagsContainer.appendChild(tagElement);
        });

        return tagsContainer;
    }

    // Méthode pour gérer l'état actif des boutons
    updateActiveButton = (activeButton) => {
        const buttons = document.querySelectorAll('.heypster-buttons-container .heypster-button');

        buttons.forEach(button => {
            const baseName = button.dataset.name; 
            if (button === activeButton) {
                button.src = `https://heypster-gif.com/sdk/V2/assets/img/icons/${baseName}-active.png`;
            } else {
                button.src = `https://heypster-gif.com/sdk/V2/assets/img/icons/${baseName}.png`;
            }
        });
    };

}